import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const QueensBenchPage = lazy(() => import('../pages/properties/queens-bench/page'));
const GoldenTrianglePage = lazy(() => import('../pages/properties/golden-triangle/page'));
const TokenizationPage = lazy(() => import('../pages/tokenization/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const AMLPolicyPage = lazy(() => import('../pages/legal/aml-policy/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/legal/privacy-policy/page'));
const TermsOfUsePage = lazy(() => import('../pages/legal/terms-of-use/page'));
const CookiesPolicyPage = lazy(() => import('../pages/legal/cookies-policy/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/properties/queens-bench',
    element: <QueensBenchPage />,
  },
  {
    path: '/properties/golden-triangle',
    element: <GoldenTrianglePage />,
  },
  {
    path: '/tokenization',
    element: <TokenizationPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/aml-policy',
    element: <AMLPolicyPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms-of-use',
    element: <TermsOfUsePage />,
  },
  {
    path: '/cookies-policy',
    element: <CookiesPolicyPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
